export const NEW_CUSTOMER_TAG = "NEW_CUSTOMER_TAG";
export const NEW_CUSTOMER_TAG_SUCCESS = "NEW_CUSTOMER_TAG_SUCCESS";
export const NEW_CUSTOMER_TAG_FAIL = "NEW_CUSTOMER_TAG_FAIL";
